/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import React, { useEffect, useState } from 'react'
import io from 'socket.io-client'
import MagnifyIcon from 'mdi-react/MagnifyIcon'
import { Card, Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap'
import { useDebouncedCallback } from 'use-debounce'
import classnames from 'classnames'
import ReactLoading from 'react-loading'
import { APP } from 'Configs/App'
import PlaylistCard from './PlaylistsCard'
import PlaylistDetailsModal from './PlaylistDetailsModal'

const PlaylistsTable = ({
  playlists,
  getPlaylists,
  totalPlaylists,
  allFoundPlaylists,
  searchPlaylists,
  getPlaylistInfo,
  setIsNewParameter,
  activatePlaylist,
  deactivatePlaylist,
}) => {
  const [isSearch, setIsSearch] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [foundPlaylists, setFoundPlaylists] = useState([])
  const [activeTab, setActiveTab] = useState('1')
  const [activeTabName, setActiveTabName] = useState('all')
  const [modal, setModal] = useState(false)
  const [playlist, setPlaylist] = useState({})
  const [playlistStatus, setPlaylistStatus] = useState('')
  const [isError, setIsError] = useState(false)
  const [isSubmitSuccessful, setIsSubmitSuccessful] = useState(false)
  const [isModalLoading, setIsModalLoading] = useState(false)
  const [detailShow, setDetailsShow] = useState(false)

  const socket = io(`${APP.SOCKET_URL}`, { path: '/my-custom-path/' })

  useEffect(() => {
    socket.on('discovery_on', data => {
      setIsModalLoading(false)
      setPlaylist(data.playlist)
    })
  }, [socket])

  const toggle = (tab, tabName) => {
    activeTab !== tab && setActiveTab(tab)
    if (activeTabName !== tabName) {
      setActiveTabName(tabName)
      getPlaylists(tabName, 1)
    }
  }

  const modalToggle = () => {
    setModal(!modal)
    modal && setDetailsShow(false)
  }

  useEffect(() => {
    getPlaylists('all', 1)
  }, [])

  useEffect(() => {
    setFoundPlaylists(allFoundPlaylists.slice(0, 5))
  }, [allFoundPlaylists])

  const [debouncedCallback] = useDebouncedCallback(value => {
    searchPlaylists(value, error => {
      if (!error) {
        setTimeout(() => {
          setIsLoading(false)
        }, 500)
      }
    })
  }, 1000)

  const handleFindPlaylist = str => {
    if (!str.length) {
      setIsSearch(false)
    } else {
      setIsLoading(true)
      setIsSearch(true)
      debouncedCallback(str)
    }
  }

  const handleActivatePlaylist = id => {
    setPlaylistStatus('Activated')
    setIsModalLoading(true)
    activatePlaylist(id, error => {
      if (!error) {
        setIsModalLoading(false)
        setIsSubmitSuccessful(true)
        setIsNewParameter(id)
      }
    })
  }

  const handleDeactivatePlaylist = id => {
    setPlaylistStatus('Deactivated')
    setIsModalLoading(true)
    deactivatePlaylist(id, error => {
      if (!error) {
        setIsModalLoading(false)
        setIsSubmitSuccessful(true)
      }
    })
  }

  const handleRefreshDiscoveredOn = id => {
    setIsModalLoading(true)

    socket.emit('discovery_on', id)
  }

  return (
    <>
      <Card className="tabs-wrapper">
        <div className="tabs tabs--bordered-bottom">
          <div className={`tabs__wrap ${isSearch && 'search-tab'} admin-tabs`}>
            {!isSearch && (
              <Nav tabs>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '1' })}
                    onClick={() => {
                      toggle('1', 'all')
                    }}
                  >
                    All &ensp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '2' })}
                    onClick={() => {
                      toggle('2', 'new')
                    }}
                  >
                    New &ensp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '3' })}
                    onClick={() => {
                      toggle('3', 'pending')
                    }}
                  >
                    Review needed &ensp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '4' })}
                    onClick={() => {
                      toggle('4', 'activated')
                    }}
                  >
                    Activated &ensp;
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className={classnames({ active: activeTab === '5' })}
                    onClick={() => {
                      toggle('5', 'deactivated')
                    }}
                  >
                    Deactivated &ensp;
                  </NavLink>
                </NavItem>
              </Nav>
            )}
            <span className="search-wrapper">
              <div className="inbox__emails-control-search">
                <input
                  placeholder="Search"
                  onChange={e => handleFindPlaylist(e.target.value)}
                />
                <div className="inbox__emails-control-search-icon">
                  <MagnifyIcon />
                </div>
              </div>
            </span>
          </div>
        </div>
        <TabContent activeTab={activeTab}>
          <TabPane tabId={activeTab}>
            {isLoading ? (
              <ReactLoading
                className="users-loading loading"
                height={24}
                type="spinningBubbles"
              />
            ) : (
              <PlaylistCard
                isError={isError}
                isLoading={isModalLoading}
                isSubmitSuccessful={isSubmitSuccessful}
                item={playlist}
                modal={modal}
                itemstatus={playlistStatus}
                activatePlaylist={handleActivatePlaylist}
                deactivatePlaylist={handleDeactivatePlaylist}
                handleRefreshDiscoveredOn={handleRefreshDiscoveredOn}
                allFoundPlaylists={allFoundPlaylists}
                getPlaylists={getPlaylists}
                isSearch={isSearch}
                setFoundPlaylists={setFoundPlaylists}
                totalPlaylist={
                  isSearch ? allFoundPlaylists.length : totalPlaylists
                }
                playlists={isSearch ? foundPlaylists : playlists}
                tabName={activeTabName}
                modalToggle={modalToggle}
                setPlaylist={setPlaylist}
                getPlaylistInfo={getPlaylistInfo}
                setIsModalLoading={setIsModalLoading}
                setPlaylistStatus={setPlaylistStatus}
                setIsNewParameter={setIsNewParameter}
                setIsSubmitSuccessful={setIsSubmitSuccessful}
                setIsError={setIsError}
                detailShow={detailShow}
                setDetailsShow={setDetailsShow}
              />
            )}
          </TabPane>
        </TabContent>
      </Card>
    </>
  )
}

export default PlaylistsTable
